import { useForm as useFormHook } from "hooks";
import { JsonableFields } from "consts/onboarding";
import { converStringtoArray, convertToDateTime } from "util/transformers";
import type { OnboardingBusinessInformation as OnboardingBusinessInformationType } from 'features/onboarding/types';
import ShoppingPlatforms from "features/onboarding/ShoppingPlatforms";
import {
    FormField,
    OnboardingBusinessInformation,
    OnboardingBusinessInformationForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    companyName,
    registrationNumber,
    websiteUrl,
    primaryLocation,
    platforms,
    yearEstablished,
    countriesOfBusinessActivity,
    ...restInitialValues
}: Partial<OnboardingBusinessInformationType>): OnboardingBusinessInformation => ({
    [FormField.CompanyName]: companyName ?? '',
    [FormField.RegistrationNumber]: registrationNumber ?? '',
    [FormField.CountryOfIncorporation]: null,
    [FormField.WebsiteUrl]: websiteUrl ?? '',
    [FormField.PrimaryLocation]: primaryLocation ?? '',
    [FormField.YearEstablished]: convertToDateTime(yearEstablished),
    [FormField.Platforms]: ShoppingPlatforms.make(platforms)
        .parse()
        .toKeys(),
    [FormField.CountriesOfBusinessActivity]: converStringtoArray(countriesOfBusinessActivity ?? ''),
    [JsonableFields.RequestedChangeFields]: null,
    [JsonableFields.FieldsStatuses]: null,
    [JsonableFields.FieldsComments]: null,
    ...restInitialValues
});

export const useForm = (onboardingBusinessInformation: OnboardingBusinessInformationForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingBusinessInformation,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
